import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ShopPage} from "../shop/shop";

/**
 * Generated class for the DiscoveryFeedListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-discovery-feed-list',
    templateUrl: 'discovery-feed-list.html',
})
export class DiscoveryFeedListPage {

    shops: any;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.shops = navParams.get('shops');
    }

    openPage(event: any, shop: object) {
        this.navCtrl.push(ShopPage, {
            shop: shop
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/discovery-feed-list/discovery-feed-list.ts